import React from 'react';
import './Gis.css';
import path from '../path';
import nic_logo from './images/nic-1.png';
import logo from './images/finance-logo.jpg';
import amrit from './images/amrit.png';
import mygov from './images/mygov.png';
const Gis_Header = () => {
	const config = path();
    return (
        <header className="d-flex justify-content-center align-items-center head py-3" style={{ margin: '0 auto' }}>
            <div className="container">
                <div className="row align-items-center">
                    {/* Left Image */}
                    <div className="col-4 col-sm-3 col-md-2 text-center logoicon">
                        <img
                            src={logo} // Replace with your image path
                            alt="Finance Logo"
                            className="img-fluid"
                            style={{ maxHeight: '65px' }}
                        />
                    </div>

                    {/* Center Text */}
                    <div className="col-8 col-sm-6 col-md-6 text-center texticon">
                        <h1
                            className="fw-bold text-wrap mb-0"
                            style={{ fontSize: 'calc(1rem + 0.5vw)' }}
                        >
						{config.gisheadername}
                        </h1>
                    </div>

                    {/* Right Images */}
                    <div className="col-12 col-sm-3 col-md-4 d-flex justify-content-center justify-content-md-evenly align-items-center mt-3 mt-sm-0 mobhead">
                        <img
                            src={nic_logo} // Replace with your image path
                            alt="NIC Logo"
                            className="img-fluid"
                            style={{ maxHeight: '50px' }}
                        />
                        <img
                            src={amrit} // Replace with your image path
                            alt="Amrit Logo"
                            className="img-fluid"
                            style={{ maxHeight: '50px' }}
                        />
                        <img
                            src={mygov} // Replace with your image path
                            alt="MyGov Logo"
                            className="img-fluid"
                            style={{ maxHeight: '67px' }}
                        />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Gis_Header;